import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { usdcContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const AllowanceUsdc = () => {

  // const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.chinaTomi;
  const tokenAddress1 = Environment.usdc
  const contract = usdcContract(tokenAddress1, web3);


  const allowanceUsdc = useCallback(
    async () => {
        // console.log(tokenAddress,account,'noor');
      try {
        const buy = await contract.methods.allowance(account,tokenAddress).call()
        // console.log('sdsdss' ,  buy)
        return buy/10**6;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return { allowanceUsdc: allowanceUsdc };
};
export default AllowanceUsdc;